var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.775 5.2342C16.4175 4.8767 15.84 4.8767 15.4825 5.2342L11 9.70753L6.51753 5.22503C6.16003 4.86753 5.58253 4.86753 5.22503 5.22503C4.86753 5.58253 4.86753 6.16003 5.22503 6.51753L9.70753 11L5.22503 15.4825C4.86753 15.84 4.86753 16.4175 5.22503 16.775C5.58253 17.1325 6.16003 17.1325 6.51753 16.775L11 12.2925L15.4825 16.775C15.84 17.1325 16.4175 17.1325 16.775 16.775C17.1325 16.4175 17.1325 15.84 16.775 15.4825L12.2925 11L16.775 6.51753C17.1234 6.1692 17.1234 5.58253 16.775 5.2342Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClear);
export default __webpack_public_path__ + "static/media/clear.c0910fcc38f447081fc831a9b6c8badc.svg";
export { ForwardRef as ReactComponent };